import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#8b5cf6', dark: '#6d28d9', light: '#c4b5fd' },
    secondary: { main: '#ec4899', dark: '#be185d', light: '#fbcfe8' },
    success: { main: '#22c55e' },
    warning: { main: '#f59e0b' },
    error: { main: '#ef4444' },
    background: { default: '#ffffff', paper: '#ffffff' },
    text: { primary: '#231942', secondary: '#6b5f82' },
    divider: '#e9e3f4',
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: 'Inter, Montserrat, Arial, sans-serif',
    h4: { fontWeight: 800, letterSpacing: 0 },
    h5: { fontWeight: 800, letterSpacing: 0 },
    h6: { fontWeight: 700, letterSpacing: 0 },
    button: { fontWeight: 700, letterSpacing: 0, textTransform: 'none' },
  },
  components: {
    MuiTableContainer: {
      styleOverrides: {
        root: {
          width: '100%',
          overflowX: 'auto',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          minWidth: 760,
          borderCollapse: 'separate',
          borderSpacing: 0,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          whiteSpace: 'nowrap',
          borderBottom: '1px solid #e9e3f4',
        },
        head: {
          backgroundColor: '#f8f7fb',
          color: '#6b5f82',
          fontSize: 12,
          fontWeight: 800,
          textTransform: 'uppercase',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd) .MuiTableCell-body': {
            backgroundColor: '#ffffff',
          },
          '&:nth-of-type(even) .MuiTableCell-body': {
            backgroundColor: '#f8f7fb',
          },
          '&.MuiTableRow-hover:hover .MuiTableCell-body': {
            backgroundColor: '#f1ecff',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid #e9e3f4',
          boxShadow: '0 14px 36px rgba(86, 52, 142, 0.08)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6, fontWeight: 700 },
      },
    },
  },
});
